import { Item, RenderItemFormSidebarPanelCtx } from "datocms-plugin-sdk";
import { Canvas, TextInput, Button } from "datocms-react-ui";
import { render } from 'datocms-structured-text-to-plain-text';
import { sendMessageToChatGPT } from "../utils/chatgpt";
import { useState } from "react";
import StoryGeneratorProgress, { StoryGenerationProgress } from "../components/StoryGeneratorProgress";
import { LogLevel, buildClient } from '@datocms/cma-client-browser';
import { Dast, createEnumerationDast, createParagraphs, createSimpleTextDast, createSimpleTitleDast } from "../utils/Dast";
import ResizableModal from "../components/RenderStory";
import { ClientContext, GraphQLClient } from "graphql-hooks";

type Props = {
  ctx: RenderItemFormSidebarPanelCtx,
};

function RenderStorySidePanel({ ctx }: Props) {
  const [phoneWidth, setPhoneWidth] = useState<string>("414");
  const [phoneHeight, setPhoneHeight] = useState<string>("896");

  const itemId = ctx.item?.id;
  console.log(ctx.item)
  return (
    <Canvas ctx={ctx}>
      <div>
        Phone width:
        <TextInput
          value={phoneWidth}
          onChange={setPhoneWidth}
          labelText="Phone width"
        /><br/>

        Phone height:
        <TextInput
          value={phoneHeight}
          onChange={setPhoneHeight}
        /><br/>

        <Button 
          onClick={() => {
          ctx.openModal({
            id: 'renderStory',
            title: 'Rendering current story',
            width: 'l',
            parameters: {
              id: itemId,
              width: Number(phoneWidth),
              height: Number(phoneHeight),
              cardContent: ctx.formValues,
              locale: ctx.locale
            },
          });
        }}>Render story cards</Button>
      </div>
    </Canvas>
  );
};

export default RenderStorySidePanel;